import * as React from "react";
import type {
  MergedTimelineEntry,
  StudyRecordLike,
} from "../domains/MergedTimelineEntry";
import { useFetchTimelineDrillProgress } from "./http/useFetchTimelineDrillProgress";

// マージ済みタイムラインの表示中エントリから、ドリル教材の学習記録を抽出して
// 学習定着バー（drillProgressMap）を取得する。学習記録固有の関心事のため、校舎
// リアルタイムタブ・生徒タイムラインの両オーケストレーションフックから共通利用する。
export const useTimelineDrillProgress = <
  // recordedAt は MergedTimelineEntry の StudyRecordLike が要求するため重複させず合成する。
  // 本フックが追加で参照するのは id と learningMaterial.isTypeDrill / notee のみ。
  S extends StudyRecordLike & {
    id: string;
    learningMaterial?: { isTypeDrill?: boolean; notee?: boolean | null } | null;
  },
>(
  sectionId: string,
  displayed: MergedTimelineEntry<S>[],
) => {
  const drillStudyRecordIds = React.useMemo(
    () =>
      displayed.flatMap((entry) =>
        entry.studyRecord.learningMaterial?.isTypeDrill &&
        // Notee 教材は通常教材として表示するため定着度は取得しない
        !entry.studyRecord.learningMaterial?.notee
          ? [entry.studyRecord.id]
          : [],
      ),
    [displayed],
  );

  const { data } = useFetchTimelineDrillProgress({
    sectionId,
    studyRecordIds: drillStudyRecordIds,
    enabled: drillStudyRecordIds.length > 0,
  });

  return data;
};
